import { render, staticRenderFns } from "./ScormReportDetails.vue?vue&type=template&id=5bb749a8"
import script from "./ScormReportDetails.vue?vue&type=script&lang=js"
export * from "./ScormReportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports